import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppChatDetailsPage } from './app-chat-details';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppChatDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(AppChatDetailsPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppChatDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-chat-details/app-chat-details.module.ts